import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dayOfMonth' })
export class DayOfMonthPipe implements PipeTransform {

  public transform(s: number): string {
    if (s.toString().endsWith('1') && !s.toString().startsWith('1') ||
        s.toString().endsWith('1') && s.toString().length === 1
    ) {
      return `${s.toString()}st`;
    } else if (s.toString().endsWith('2') && !s.toString().startsWith('1')) {
      return `${s.toString()}nd`;
    } else if (s.toString().endsWith('3') && !s.toString().startsWith('1')) {
      return `${s.toString()}rd`;
    } else {
      return `${s.toString()}th`;
    }
  }
}
